class AccessClass {
  constructor() {
    this.subtitle = {
      en: "Here are the ways to come from Shin-Okubo Station and Higashi-Shinjuku Station. Additionally, instructions on how to come from Narita Airport and Haneda Airport are provided.",
      jp: "新大久保駅および東新宿駅からの行き方は次の通りです。また、成田空港および羽田空港からの行き方も説明します。",
      kr: "신오쿠보역 및 히가시신주쿠역에서 오는 방법은 다음과 같습니다. 나리타 공항 및 하네다 공항에서 오는 방법도 설명합니다.",
      cn: "下面介绍从新大久保站和东新宿站的交通方式。另外，还介绍了从成田机场和羽田机场出发的交通方式。"
    }

    this.from_nearby_station =
    {
      en: {
        title: "From Nearby Stations",
        guide: "Please, click the station's name below to open the access information. Click again to close the info.",
        summary: "Here are the ways from Shin-Okubo Station and Higashi-Shinjuku Station. Additionally, instructions on how to come to the Sophiearth Hotel from Narita Airport and Haneda Airport are provided.",
        directions: [
          {
            id: "Shin Okubo Station",
            from: "Shin Okubo - 10 minute walk",
            by: [
              {
                title: 'walk',
                des: ["There is only one exit at Shin-Okubo Station. Upon exiting the station, turn right and walk for about 500 meters until you reach the 100-yen shop (Can Do). From the 100-yen shop, continue straight for about 150 meters until you reach the DIY store. Passing the DIY store, you will come to the first traffic light, where you will find a narrow alley. On one side, there is a real estate agency, and on the other side, there is an Osteopath hospital. Enter that alley and walk for about 80 meters until you see the sign for Sophiearth Hotel.", "Please refer to the map below."]
              }
            ],
            photo: "photos/access/shinokubo_access.png"
          },
          {
            id: "Higashi Shinjuku Station",
            from: "Higashi Shinjuku - 2 minute walk",
            by: [
              {
                title: 'walk',
                des: ["Come out through Exit B and walk along the adjacent alley until you reach a dead end. At the end, turn right and walk 10 meters to find us.", "See the map below."
                ]
              }
            ],
            photo: "photos/access/higashi_shinjuku_access.png"
          }
        ]
      },
      jp: {
        title: "ホテル周辺の駅から",
        guide: "以下の駅名をクリックすると、アクセス情報が表示されます。情報を閉じるにはもう一度クリックしてください。",
        summary: "",
        directions: [
          {
            id: "新大久保駅",
            from: "新大久保駅 - 徒歩10分",
            by: [
              {
                title: 'walk',
                des: ["新大久保駅には1つの出口しかありません。駅を出て右に向かい、約500メートル歩いて100円ショップ（キャンドゥ）に到着します。 100円ショップからまっすぐ進み、約150メートル歩くとDIYストアに到着します。 DIYストアを通過すると、最初の信号に至ります。そこには狭い路地があります。片側には不動産会社、もう片側には整骨院があります。その路地に入り、約80メートル歩くと、Sophiearth Hotelの看板が見えます。",
                  "下の地図をご参照ください。"]
              }
            ],
            photo: "photos/access/shinokubo_access.png"
          },
          {
            id: "東新宿駅",
            from: "東新宿駅 - 徒歩2分",
            by: [
              {
                title: 'walk',
                des: ["出口Bから出て、隣接する路地沿いに歩いて、行き止まりに至るまで歩いてください。最後に、右に曲がり、10メートル歩いて私たちを見つけてください。", "下の地図をご覧ください。"]
              }
            ],
            photo: "photos/access/higashi_shinjuku_access.png"
          }
        ]
      },
      kr: {
        title: "호텔 주위의 전철역으로부터",
        guide: "아래에서 역 이름을 클릭하시면 액세스 정보를 보실 수 있습니다. 정보를 닫으려면 다시 클릭하세요.",
        summary: "신오쿠보역 및 히가시신주쿠역에서 오는 방법은 다음과 같습니다. 나리타 공항 및 하네다 공항에서 오는 방법도 설명합니다.",
        directions: [
          {
            id: "신오쿠보 역",
            from: "신오쿠보역 - 도보10분",
            by: [
              {
                title: 'walk',
                des: ["신오쿠보역은 출구가 1개뿐입니다. 출구에서 나와서 우회전하여 100엔샵(Can Do)이 보일 때까지 약 500m 걸어가세요. 100엔숍에서 150m 정도 직진하면 DIY 매장이 나옵니다. DIY 매장 지나 첫 번째 신호등에서 좁은 골목이 나옵니다. 한쪽에는 부동산이 있고, 다른 한쪽에는 접골의원이 있습니다. 약 80m 정도 골목으로 들어가시면 숙소를 찾으실 수 있습니다.",
                  "아래 지도를 참조하세요."]
              }
            ],
            photo: "photos/access/shinokubo_access.png"
          },
          {
            id: "히가시 신주쿠 역",
            from: "히가시 신주쿠 역 - 도보 2분",
            by: [
              {
                title: 'walk',
                des: ["출구 B로 나와서 출구B에 붙은 조그만 골목을 따라서 약 200미터 걸으시면 막다른 길에 도달합니다. 막다른 곳에서 오른쪽으로 돌아서 10미터 가시면 숙소를 찾을수 있습니다.",
                  "아래 지도를 참조하세요."
                ]
              }
            ],
            photo: "photos/access/higashi_shinjuku_access.png"
          }
        ]
      },
      cn: {
        title: "附近车站",
        guide: "请点击下面的车站名称以查看访问信息。再次点击以关闭信息。",
        summary: "请点击下面的车站名称以查看访问信息。再次点击以关闭信息。中文。",
        directions: [
          {
            id: "新大久保",
            from: "新大久保 - 徒歩10分",
            by: [
              {
                title: 'walk',
                des: ["新大久保站只有一个出口。从车站出口右转，步行约500米直到到达100日元商店（Can Do）。从100日元商店继续直行约150米直到到达DIY商店。经过DIY商店，您将来到第一个红绿灯处，那里有一条窄巷。一侧是房地产公司，另一侧是整骨医院。进入那条小巷，步行约80米直到看到Sophiearth Hotel的招牌。",
                  "请参考下面的地图。"
                ]
              }
            ],
            photo: "photos/access/shinokubo_access.png"
          },
          {
            id: "东新宿站",
            from: "东新宿站 - 徒歩2分",
            by: [
              {
                title: 'walk',
                des: ["从B出口出来，沿着相邻的小巷走，直到走到尽头。在尽头，右转，走10米就能找到我们。",
                  "请参考下面的地图。"]
              }
            ],
            photo: "photos/access/higashi_shinjuku_access.png"
          }
        ]
      },
    }

    this.from_airports =
    {
      en: {
        title: "From Airports",
        guide: "Please, click the airport name below to open the access information. Click again to close the info.",
        summary: "Instructions on how to come from Narita Airport and Haneda Airport are provided.",
        directions:
          [
            {
              from: "Haneda Airport",
              by: [
                {
                  title: 'Limousine Bus',
                  des: ["Ride a limousine bus from the airport to the Shinjuku Station (JPY 1,300, 45 mins). From the Shinjuku Station, you can either walk 15 minutes or ride a taxi (7 minutes, 1,000 Yen). "],
                },
                {
                  title: 'Keikyu Airport Line + Yamanote Line',
                  des: ["Ride the Keikyu Airport Line to the Sinagawa Station (JPY 410, 11 mins). At the Sinagawa Station, switch to Yamanote Line for Shin Okubo Station (JPY 194, 22 mins). From the Shin Okubo Station, please follow the directions given above.",
                  ],
                }
              ],
              photo: "photos/access/haneda_access.png"
            },
            {
              from: "Narita Airport",
              by: [
                {
                  title: 'Limousine Bus',
                  des: ["Ride a limousine bus from the airport to the Shinjuku Station (JPY 3,300, 100 mins). From the Shinjuku Station, you can either walk 15 minutes or ride a taxi (7 minutes, 1,000 Yen). "]
                },
                {
                  title: 'Skyliner / Keisei / Narita Express',
                  des: ["Ride the Skyliner or Keisei Line or Narita Express from the airport to the Nippori Station. At the Nippori Station, switch to the JR Yamanote Line for Shin Okubo station (JPY 165, 19 mins). From the Shin Okubo Station, please, follow directions for Shin Okubo Station given above.",
                    "Skyliner (JPY 2,430, 45 mins), Keisei Line (JPY 1,240, 70 mins), Narita Express (JPY 1,800, 90 mins)"
                  ]
                },
                {
                  title: 'Access Narita Bus', des: ["Ride the Access Narita Bus (JPY 1,000, 70 mins) for the Ginza Station (Terminal 1: bus platform #31, Terminal 2: bus platform #2, #19). At the Ginza station, ride the Marunouchi Subway Line for Shinjuku 3 Chome Station (JPY 195, 14 mins). From the Shinjuku 3 Chome Station, you can either walk for 15 minutes or take a taxi."
                  ]
                }
              ],
              photo: "photos/access/narita_access.png"
            },
          ]
      },
      kr: {
        title: "공항으로부터",
        guide: "아래 공항 이름을 클릭하면 오는 길이 안내됩니다. 다시 한번 클릭하면 정보 창이 닫칩니다.",
        summary: "나리타공항 / 하네다 공항으로부터 오는 길을 안내합니다.",
        directions:
          [
            {
              from: "하네다 공항",
              by: [
                {
                  title: '리무진 버스',
                  des: ["공항에서 신주쿠 역까지 리무진 버스를 타세요 (1,300 엔, 45 분). 신주쿠 역에서는 15 분 도보 또는 택시를 탈 수 있습니다 (7 분, 1,000 엔)."],
                },
                {
                  title: '케이큐공항선 + 야마노테선',
                  des: ["케이큐공항선을 타고 시나가와 역까지 이동하세요 (JPY 410, 11 분). 시나가와 역에서 야마노테 라인으로 갈아타서 신오쿠보 역으로 가세요 (JPY 194, 22 분). 신오쿠보 역에서는 앞서 설명한 방법에 따라 진행해주세요."
                  ],
                }
              ],
              photo: "photos/access/haneda_access.png"
            },
            {
              from: "나리타 공항",
              by: [
                {
                  title: '리무진버스',
                  des: ["공항에서 신주쿠 역까지 리무진 버스를 타세요 (JPY 3,300, 100 분). 신주쿠 역에서는 15 분 도보 또는 택시를 탈 수 있습니다 (7 분, 1,000 엔)."]
                },
                {
                  title: '스카이라이너 / 京成 라인 / 나리타 익스프레스',
                  des: ["공항에서 스카이라이너, 京成 라인 또는 나리타 익스프레스를 타고 니포리 역까지 이동합니다. 니포리 역에서 JR 야마노테 선으로 신오쿠보 역행 기차로 갈아탑니다 (165 엔, 19 분). 신오쿠보 역에서는 위에서 제공된 신오쿠보 역 안내를 따라 주십시오.",
                    "스카이라이너 (2,430 엔, 45 분), 京成 라인 (1,240 엔, 70 분), 나리타 익스프레스 (1,800 엔, 90 분)"
                  ]
                },
                {
                  title: 'Access Narita Bus', des: [
                    "Access Narita 버스를 타고 (JPY 1,000, 70 분) 긴자 역까지 이동합니다 (터미널 1: 버스 플랫폼 #31, 터미널 2: 버스 플랫폼 #2, #19). 긴자 역에서, 마루노우치 지하철 라인으로 신주쿠 3 쵸메 역까지 이동합니다 (JPY 195, 14 분).  신주쿠 3 쵸메 역에서는 도보로 15분 걸어가거나 택시를 이용할 수 있습니다."
                  ]
                }
              ],
              photo: "photos/access/narita_access.png"
            },
          ]
      },
      jp: {
        title: "空港から",
        guide: "下記の空港名をクリックするとアクセス情報が開きます。もう一度クリックすると情報が閉じます。",
        summary: "成田空港/羽田空港からの道を案内します。",
        directions:
          [
            {
              from: "羽田空港",
              by: [
                {
                  title: 'リムジンバス',
                  des: ["空港から新宿駅までリムジンバスに乗る（1,300円、45分）。新宿駅からは、徒歩15分かタクシーに乗ることができます（7分、1,000円）。"],
                },
                {
                  title: '京急空港線＋山手線',
                  des: ["京急空港線に乗って品川駅まで行きます（410円、11分）。品川駅で山手線に乗り換え、新大久保駅まで行きます（194円、22分）。新大久保駅からは、上記の指示に従ってください。"
                  ],
                }
              ],
              photo: "photos/access/haneda_access.png"
            },
            {
              from: "成田空港",
              by: [
                {
                  title: 'リムジンバス',
                  des: ["空港から新宿駅までリムジンバスに乗ってください（JPY 3,300、100 分）。新宿駅からは、徒歩で15分かタクシーを利用できます（7 分、1,000円）。"]
                },
                {
                  title: '空港からスカイライナー / 京成線 / 成田エクスプレス',
                  des: ["空港からスカイライナーや京成線、成田エクスプレスに乗って日暮里駅まで行きます。日暮里駅でJR山手線に乗り換えて新大久保駅まで行きます（165円、19分）。新大久保駅からは、上記の新大久保駅の指示に従ってください。",
                    "スカイライナー（2,430円、45分）、京成線（1,240円、70分）、成田エクスプレス（1,800円、90分）"
                  ]
                },
                {
                  title: 'Access Narita Bus', des: ["エクセス成田バスに乗ります（JPY 1,000、70分）銀座駅（ターミナル1：バスプラットフォーム31、ターミナル2：バスプラットフォーム2、19）まで。銀座駅で丸ノ内線に乗り換え、新宿3丁目駅まで移動します（JPY 195、14分）。新宿3丁目駅からは、徒歩で15分かタクシーを利用できます。"
                  ]
                }
              ],
              photo: "photos/access/narita_access.png"
            },
          ]
      },
      cn: {
        title: "从机场",
        guide: "请点击下面的机场名称以打开访问信息。再次点击关闭信息。",
        summary: "从成田机场/羽田机场到达的路线指南。",
        directions:
          [
            {
              from: "羽田空港",
              by: [
                {
                  title: '机场豪华巴士',
                  des: ["请搭乘机场到新宿站的豪华巴士（1,300日元，45分钟）。从新宿站，您可以步行15分钟或乘坐出租车7分钟（1,000日元）。"],
                },
                {
                  title: '京急机场线 + 山手线',
                  des: ["乘坐京急机场线到品川站（410日元，11分钟）。在品川站换乘山手线前往新大久保站（194日元，22分钟）。从新大久保站，请按照上面给出的指示前进。"
                  ],
                }
              ],
              photo: "photos/access/haneda_access.png"
            },
            {
              from: "成田空港",
              by: [
                {
                  title: '机场豪华巴士',
                  des: [
                    "从机场乘坐豪华巴士到新宿站（3,300日元，100分钟）。 从新宿站，您可以步行15分钟或乘坐出租车（7分钟，1,000日元）。"]
                },
                {
                  title: 'Skyliner / 京成线 / 成田特快',
                  des: ["从机场乘坐Skyliner、京成线或成田特快到达日暮里站。在日暮里站换乘JR山手线前往新大久保站（165日元，19分钟）。从新大久保站，请按照上述新大久保站的指示前进。",
                    "Skyliner（2,430日元，45分钟）、京成线（1,240日元，70分钟）、成田特快（1,800日元，90分钟）"
                  ]
                },
                {
                  title: 'Access Narita Bus', des: ["乘坐 Access Narita Bus JPY 1,000，70分钟）前往银座站（1号航站楼：巴士站台#31，2号航站楼：巴士站台#2，#19）。在银座站换乘丸之内线前往新宿三丁目站（JPY 195，14分钟）。从新宿三丁目站，您可以步行15分钟或乘坐出租车。"
                  ]
                }
              ],
              photo: "photos/access/narita_access.png"
            },
          ]
      },

    }
  }


  get_nearby_station_info(lang) {
    switch (lang) {
      case 'en': return this.from_nearby_station.en
      case 'kr': return this.from_nearby_station.kr
      case 'jp': return this.from_nearby_station.jp
      case 'cn': return this.from_nearby_station.cn
    }
  }

  get_airports_info(lang) {
    switch (lang) {
      case 'en': return this.from_airports.en
      case 'kr': return this.from_airports.kr
      case 'jp': return this.from_airports.jp
      case 'cn': return this.from_airports.cn
    }
  }

  get_subtitle(lang) {
    switch (lang) {
      case 'en': return this.subtitle.en
      case 'kr': return this.subtitle.kr
      case 'jp': return this.subtitle.jp
      case 'cn': return this.subtitle.cn
    }
  }

}
export let access = new AccessClass();
